import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";

function PageHeader({ title }) {
  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  if (isModalPage) return null;

  return (
    <div>
      <Row>
        <Col>
          <h5 style={{ fontWeight: 600, marginBottom: "8px" }}>
            {title}
          </h5>
        </Col>
      </Row>

      <hr />
    </div>
  );
}

export default PageHeader;